import { connect } from 'react-redux';
// eslint-disable-next-line import/no-named-as-default
import Reports from './Reports';
import {
  getReportCreate,
  getReportErrorClose,
  getReportTypes,
  getReportProductTypes,
  getReportUsers
} from '../../store/actions/report';
import {
  delDocumentsNextNumber,
  getDocumentsNextNumber,
  getHolderReportsByStock,
  deleteHolderReport
} from '../../store/actions/documents';
import { modalErrorOpen } from '../../store/actions/modalError';

const mapStateToProps = ({
  reportReducer,
  userReducer,
  tabsReducer,
  documentsReducer,
  popupActReducer
}) => ({
  reportReducer,
  userReducer,
  tabsReducer,
  documentsReducer,
  popupActReducer
});
const mapDispatchToProps = {
  getReportCreate,
  getReportErrorClose,
  getReportTypes,
  getReportProductTypes,
  getReportUsers,
  getHolderReportsByStock,
  getDocumentsNextNumber,
  delDocumentsNextNumber,
  deleteHolderReport,
  modalErrorOpen
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Reports);
